import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';

const OversizedFeeDetailsModalContent = ({
    oversizedFeeMessage,
    vehicleRestriction,
    hideTitle,
}) => {
    return (
        <div className="OversizedFeeDetailsModalContent">
            {!isEmpty(oversizedFeeMessage) && (
                <div className="OversizedFeeMessage">
                    {!hideTitle && <h3>Oversized Fees</h3>}
                    <p
                        dangerouslySetInnerHTML={{__html: oversizedFeeMessage}}
                    />
                </div>
            )}
            {!isEmpty(vehicleRestriction) && (
                <div className="OversizedFeeMessage">
                    {!hideTitle && <h3>Vehicle Restrictions</h3>}
                    <p dangerouslySetInnerHTML={{__html: vehicleRestriction}} />
                </div>
            )}
        </div>
    );
};

OversizedFeeDetailsModalContent.propTypes = {
    oversizedFeeMessage: PropTypes.string,
    vehicleRestriction: PropTypes.string,
    hideTitle: PropTypes.bool,
};

export default OversizedFeeDetailsModalContent;
